import { render } from "./Gym.vue?vue&type=template&id=57af0b21"
import script from "./Gym.vue?vue&type=script&lang=js"
export * from "./Gym.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__